import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import Select from "react-select";
import { AuthContext } from '../../context/AuthContext';
import { ContaProvisionadaContext } from '../../context/ContaProvisionadaContext';
import { ContaFinanceiraContext } from '../../context/ContaFinanceiraContext';
import { CategoriaFinanceiraContext } from '../../context/CategoriaFinanceiraContext';
import { TipoContaPagarContext } from '../../context/TipoContaPagarContext';
import { FormaPagamentoContext } from '../../context/FormaPagamentoContext';
import { ContaProvisionadaType, CreateContaProvisionadaType, UpdateContaProvisionadaType } from '../../context/hooks/useContaProvisionada';
import useUser from '../../context/hooks/useUser';

import { CreateContaProvisionadaModal } from '../../components/ContaProvisionada/CreateContaProvisionadaModal';
import { EditContaProvisionadaModal } from '../../components/ContaProvisionada/EditContaProvisionadaModal';

const ContaProvisionada = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listContaProvisionada, contaProvisionadaPageCount, getAllContaProvisionadaPaged, deleteContaProvisionada } = useContext(ContaProvisionadaContext);
    const { handleGetContaFinanceiraByEmpresaId, listContaFinanceiraByEmpresa } = useContext(ContaFinanceiraContext);
    const { handleGetCategoriaFinanceiraByEmpresaId, listCategoriaFinanceiraByEmpresa } = useContext(CategoriaFinanceiraContext);
    const { handleGetFormaPagamentoByEmpresaId, listFormaPagamentoByEmpresa } = useContext(FormaPagamentoContext);
    const { handleGetTipoContaPagarByEmpresaId, listTipoContaPagarByEmpresa } = useContext(TipoContaPagarContext);
    const { getPermissionsByUser, userPermissions } = useUser();
    const [editingContaProvisionada, setEditingContaProvisionada] = useState<UpdateContaProvisionadaType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [createMultiplasModalOpen, setCreateMultiplasModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);

    const [filters, setFilters] = useState({
        dataInicial: '',
    });

    useEffect(() => {
        setLoading(true);

        handleGetCategoriaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        handleGetContaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        handleGetFormaPagamentoByEmpresaId(objUserTk.EmpresaId);
        handleGetTipoContaPagarByEmpresaId(objUserTk.EmpresaId);

        getAllContaProvisionadaPaged(1, pageSize, objUserTk.EmpresaId, "")
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar contas:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllContaProvisionadaPaged(
            value,
            pageSize,
            objUserTk.EmpresaId,
            filters.dataInicial,
        );
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllContaProvisionadaPaged(
            1,
            pageSize,
            objUserTk.EmpresaId,
            filters.dataInicial,
        )
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({
            dataInicial: '',
        });
        setLoading(true);
        getAllContaProvisionadaPaged(1, pageSize, objUserTk.EmpresaId, "")
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleEditContaProvisionada = (contaProvisionada: ContaProvisionadaType) => {
        setEditingContaProvisionada(contaProvisionada);
        setEditModalOpen(true);
    };

    const handleDeleteContaProvisionada = (contaProvisionadaId: number) => {
        if (window.confirm("Tem certeza que deseja excluir esta conta?")) {
            deleteContaProvisionada(contaProvisionadaId)
                .then(deletedContaProvisionada => {
                    if (deletedContaProvisionada) {
                        getAllContaProvisionadaPaged(1, pageSize, objUserTk.EmpresaId, "");
                    } else {
                        console.error("Erro ao excluir conta.");
                    }
                    getAllContaProvisionadaPaged(1, pageSize, objUserTk.EmpresaId, "");
                })
                .catch(error => {
                    console.error("Erro ao excluir conta:", error);
                });
        }
    };

    const listCategoriaFinanceiraOptions = listCategoriaFinanceiraByEmpresa.map(categoriaFinanceira => ({
        value: categoriaFinanceira.id,
        label: categoriaFinanceira.name,
    }));

    const listContaFinanceiraOptions = listContaFinanceiraByEmpresa.map(contaFinanceira => ({
        value: contaFinanceira.id,
        label: contaFinanceira.name,
    }));

    const listFormaPagamentoOptions = listFormaPagamentoByEmpresa.map(fp => ({
        value: fp.id,
        label: fp.name
    }));

    const listTipoContaPagarOptions = listTipoContaPagarByEmpresa.map(tp => ({
        value: tp.id,
        label: tp.name
    }));

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Contas Provisionadas"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-2">
                    <Col xs="12" md="3" className="mb-2">
                        <Label className="form-control-label">Data Inicial</Label>
                        <Input
                            className="form-control-alternative"
                            type="date"
                            name="dataInicial"
                            value={filters.dataInicial}
                            onChange={handleFilterChange}
                            placeholder="Data inicial"
                        />
                    </Col>
                    <Col xs="12" className="d-flex justify-content-start justify-content-md-end">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            onClick={handleSearch}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                    {userPermissions.includes(1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar conta
                            </Button>
                        </Col>
                    )}
                </Row>

                {userPermissions.includes(2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Código Transação</th>
                                        <th>Documento</th>
                                        <th>Observação</th>
                                        <th>Data Inicial</th>
                                        <th>Valor</th>
                                        <th>Taxa</th>
                                        <th>Recorrencia</th>
                                        <th>Forma Pgmt.</th>
                                        <th>Tipo Conta Pagar</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listContaProvisionada.map((contaProvisionada: ContaProvisionadaType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{contaProvisionada.id}</td>
                                                <td>{contaProvisionada.codigoTransacao}</td>
                                                <td>{contaProvisionada.documento}</td>
                                                <td>{contaProvisionada.historico}</td>
                                                {/* <td>{new Date(contaProvisionada.dataInicial).toLocaleDateString('pt-BR')}</td> */}
                                                <td>{contaProvisionada.dataInicial && contaProvisionada.dataInicial.split('-').reverse().join('/')}</td>
                                                <td>{contaProvisionada.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>{contaProvisionada.taxa.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>
                                                    {contaProvisionada.recorrencia === 0 && <span className="badge badge-warning">Diário</span>}
                                                    {contaProvisionada.recorrencia === 1 && <span className="badge badge-success">Semanal</span>}
                                                    {contaProvisionada.recorrencia === 2 && <span className="badge badge-success">Mensal</span>}
                                                    {contaProvisionada.recorrencia === 3 && <span className="badge badge-success">Anual</span>}
                                                </td>
                                                <td>{contaProvisionada.formaPagamentoName}</td>
                                                <td>{contaProvisionada.tipoContaPagarName}</td>
                                                <td>
                                                    {userPermissions.includes(3) && (
                                                        <Button onClick={() => { handleEditContaProvisionada(contaProvisionada) }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {userPermissions.includes(4) && (
                                                        <Button onClick={() => handleDeleteContaProvisionada(contaProvisionada.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            {/* <div className="d-flex justify-content-end mt-3">
                                {contaProvisionadaPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={contaProvisionadaPageCount}
                                        />
                                    </div>
                                )}
                                {listContaProvisionada.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div> */}
                            <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">
                                <div className="mb-2 mb-md-0">
                                    <Label className="form-control-label mr-2">Registros por página:</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        bsSize="sm"
                                        style={{ width: "100px", display: "inline-block" }}
                                        value={pageSize}
                                        onChange={(e) => {
                                            const newSize = parseInt(e.target.value);
                                            setPageSize(newSize);
                                            getAllContaProvisionadaPaged(
                                                1,
                                                newSize,
                                                objUserTk.EmpresaId,
                                                filters.dataInicial
                                            );
                                        }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={15}>15</option>
                                        <option value={20}>20</option>
                                        <option value={25}>25</option>
                                    </Input>
                                </div>

                                {contaProvisionadaPageCount && (
                                    <div className="mt-2 mt-md-0">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={contaProvisionadaPageCount}
                                        />
                                    </div>
                                )}

                                {listContaProvisionada.length === 0 && (
                                    <div className="w-100 mt-3" style={{ color: "red" }}>
                                        NÃO FOI ENCONTRADO NENHUM REGISTRO
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar as contas provisionadas.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateContaProvisionadaModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => getAllContaProvisionadaPaged(1, pageSize, objUserTk.EmpresaId, "")}
            />

            <EditContaProvisionadaModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                conta={editingContaProvisionada}
                onUpdated={() => getAllContaProvisionadaPaged(1, pageSize, objUserTk.EmpresaId, "")}
            />
        </>
    );
};

export default ContaProvisionada;